module.exports = __webpack_public_path__ + "img/w3_user_black.6bf60f75.png";